import React, { Fragment, FunctionComponent, useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop: FunctionComponent = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return <Fragment>{children}</Fragment>;
};

export default ScrollToTop;
